export const ACCESS_TOKEN = "Authorization_v1";
export const REFRESH_TOKEN = "Authorization-r_v1";
export const ACCESS_SESSION = "Access-Session_v1";
export const PLATFORM_SOURCE = "PlatformSource_v1";
export const PLATFORM_FUNCIOTN = "PlatformFunction_v1";
export const SYSTEM_VERSION = "SystemVersion_v1"; // enterprise、professional
export const ADVERTISE_MODAL = "AdvertiseModal_v1";
export const CURRENT_CORP_ID = "CurrentCorpId_v1";
